<template>
    <div class="relative block">

        <LoaderCircle v-if="loading"
                      :size="14"
                      class="absolute right-5 top-1/2 -translate-y-1/2 animate-spin text-slate-400"
        />

        <select name="calendar-category-filter" id="calendar-category-filter"
                class="rounded-xl bg-white border border-slate-300 px-4 py-2.5 w-[100%] transition-all duration-150 ease-out"
                :class="{'cursor-not-allowed text-slate-400': !loaded, 'bg-white': loaded}"
                :disabled="!loaded"
                v-model="model"
        >

            <option :value="null">{{ $t('Velg produkt') }}</option>
            <option :value="product" v-for="product in products">{{ product.product_name }}</option>
        </select>
    </div>
</template>

<script setup>
    import {ref, watchEffect} from 'vue';
    import {LoaderCircle} from "lucide-vue-next";

    const model = defineModel()
    const {products} = defineProps({
        products: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: false,
            default: true
        }
    })

    const loaded = ref(false);

    watchEffect(() => {
        loaded.value = products.length > 0;
    })
</script>